const DefaultContainer = () => import('@/containers/DefaultContainer');

const Cases = () => import('./');


const caseRoute = {
    path: '/cases',
    component: DefaultContainer,
    children: [      
      {
        path: '',
        component: Cases
      },
    ]
  };
  
  export default caseRoute;